// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class NotificationsAPI extends MainAPI {
	/**
	 * @return {object} notifications list
	 * @param {*} tableDetails - Contains pagination data
	 */
	async getNotificationList(tableDetails) {
		return API.get(`${ENDPOINTS.GET_NOTIFICATION_LIST}?${queryString.stringify(tableDetails)}`);
	}

	/**
	 * @param {*} notificationDetails
	 */
	async postNotification(notificationDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(notificationDetails.formDetails)
		);

		newFormData.append(
			'notificationImage',
			notificationDetails.notificationImage
		);

		return API.post(ENDPOINTS.POST_NOTIFICATION, newFormData);
	}

	async deleteNotification(id) {
		return API.delete(`${ENDPOINTS.DELETE_NOTIFICATION}/${id}`);
	}
	
	/**
	 * @return {object} notifications list
	 * @param {*} tableDetails - Contains pagination data
	 */
	 async getNotification(tableDetails) {
		return API.get(`${ENDPOINTS.GET_NOTIFICATION_LIST}?${queryString.stringify(tableDetails)}`);
	}

	/**
	 * @return {object} notifications details
	 * @param {id}  - Contains pagination data
	 */
	 async getNotificationById(id) {
		return API.get(`${ENDPOINTS.GET_NOTIFICATION_BY_ID}/${id}`);
	}

	/**
	 * @return {object} admin notifications list
	 * @param {*} tableDetails - Contains pagination data
	*/
	async getAdminNotificationList(tableDetails) {
		return API.get(`${ENDPOINTS.GET_ADMIN_NOTIFICATION}?${queryString.stringify(tableDetails)}`);
	}

	async putNotification(id) {
		return API.put(`${ENDPOINTS.PUT_ADMIN_NOTIFICATION}/${id}`);
	}

	/**
	 * Marks admin all notifications as read.
	 * @returns {Promise} A promise that resolves when the operation is complete.
	 */
	async markAllAsReadNotifications() {
		return API.put(`${ENDPOINTS.PUT_ALL_NOTIFICATIONS}`);
	}
}

export default new NotificationsAPI();